export default __webpack_public_path__ + "static/media/Rectangle 163.43b81e98.svg";